import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';

const HEADERS = {};

@Injectable()
export class CompareBalanceService {

  static ENV = environment;

  constructor( private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
  }
  public compareBalance(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(CompareBalanceService.ENV.environment.API.compare_balance, data, httpRequesthandler);
  }

  public compareBalanceWS(data: any , httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(CompareBalanceService.ENV.environment.API.compare_balance_ws, data, httpRequesthandler);
  }

  public compareBalanceDet(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(CompareBalanceService.ENV.environment.API.compare_balance_det, data, httpRequesthandler);
  }
  
  public compareBalanceDetWS(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(CompareBalanceService.ENV.environment.API.compare_balance_det_ws, data, httpRequesthandler);
  }
  
  public runReportCompareBalance(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(CompareBalanceService.ENV.environment.API.run_report_compare_balance, data, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/compare-balance/compare-balance.service.ts